<script>
  import { onMount, tick } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Input, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { BizCardsService } from '@client/services/bizcards';

  import { REGEXP_SPACES } from '@common/utils/regexp';
  import { isValidRuleName } from '@common/utils/validation';

  export let name = '';
  export let invalid = false;
  export let initialRulename = '';
  export let isEditor = false;

  let currentRulenames = [];
  let editingRulename = false;
  let inner = '';
  let previousRulename = '';

  const onInput = () => {
    inner.style.width = 'auto';
    inner.style.width = 4 + inner.scrollWidth + 'px';

    if (name.length) {
      name = name.replace(REGEXP_SPACES, '_');
    }
  };

  const onEditRulename = async () => {
    editingRulename = true;
    previousRulename = name;

    await tick();

    inner.focus();
  };

  const onBlur = () => {
    editingRulename = false;

    if (!name || invalid) {
      name = previousRulename;
    }
  };

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      onBlur();
    }
  };

  onMount(async () => {
    const bizCards = await BizCardsService.getAll();

    if (bizCards) {
      currentRulenames = bizCards.map((card) => card.rulename);
    }
  });

  $: if (isEditor) {
    currentRulenames = currentRulenames.filter((rulename) => rulename !== initialRulename);
  }

  $: isInvalid = currentRulenames.includes(name);
  $: isTooShort = name.length < 3;
  $: isInvalidRulename = !isValidRuleName(name);

  $: invalid = isInvalid || isTooShort || isInvalidRulename;
  $: invalidMessage = isInvalid
    ? $format('label.VALIDATION_NAME_EXISTS', {
        values: {
          type: $format('label.BUSINESS_CARD'),
          param: $format('label.NAME').toLowerCase()
        }
      })
    : isTooShort
      ? $format('label.VALIDATION_TOO_SHORT', {
          values: { param: $format('label.NAME'), length: 3 }
        })
      : $format('label.VALIDATION_ERROR_RULENAME');
</script>

{#if !editingRulename}
  <h1 class="page-title">
    <slot>{name}</slot>
    {#if name.length}
      <Icon name="edit-2" class="edit-rulename-icon" on:click={onEditRulename} />
    {/if}
  </h1>
{:else}
  <div class="edit-rulename">
    <Input
      id="rulename"
      class="rulename-input"
      placeholder="Enter a card name"
      {invalid}
      bind:inner
      bind:value={name}
      on:blur={onBlur}
      on:input={onInput}
      on:keyup={onKeyUp}
    />
    {#if invalid}
      <Tooltip isOpen={invalid} class="bizcard-tooltip" target="rulename" placement="right">
        {invalidMessage}
      </Tooltip>
    {/if}
  </div>
{/if}

<style lang="scss" src="./rulename.scss"></style>
